/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from '../GridsAndLayouts/GridsAndLayouts';
import ToggleCheckIcon from './ToggleCheckIcon';
import ToggleCloseIcon from './ToggleCloseIcon';
import './Toggle.scss';

const Toggle = ({
  checked = false,
  onChange,
  size = 'md',
  tone = 'normal',
  disabled = false,
  showIcon = false,
  className = '',
  ariaLabel,
}) => {
  const withIcons = showIcon && size === 'md';

  const classes = [
    'ds-toggle',
    `ds-toggle--${size}`,
    `ds-toggle--tone-${tone}`,
    withIcons && 'ds-toggle--with-icons',
    checked && 'ds-toggle--checked',
    disabled && 'ds-toggle--disabled',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const handleToggle = () => {
    if (disabled) return;
    if (onChange) onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      className={classes}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
    >
      <FlexRow className="ds-toggle-thumb" align="center" justify="center" inline fullWidth={false}>
        {withIcons ? (
          <FlexRow
            className="ds-toggle-thumb__inner"
            align="center"
            justify="center"
            inline
            fullWidth={false}
            aria-hidden
          >
            {checked ? <ToggleCheckIcon size={12} /> : <ToggleCloseIcon size={12} />}
          </FlexRow>
        ) : null}
      </FlexRow>
    </button>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['md', 'sm']),
  tone: PropTypes.oneOf(['normal', 'success', 'error']),
  disabled: PropTypes.bool,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Toggle;
